/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Alert,
  AlertDescription,
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Switch,
  Textarea,
} from '@jem-open/jem-ui';
import { Loader2, Plus, Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';

import apiResponseHandler from '../../../utils/apiResponseHandler';
import { environment } from '../../../environment/environment';
import { localStorageService } from '../../../services';
import {
  QUESTION_TYPES,
  PLATFORMS,
  CATEGORIES,
} from '../../../constants/educationQuestions';

const EditEducationQuestion = (props) => {
  const [state, setState] = useState({
    containerState: 'STATE_NEW',
    questionId: '',
    template: props.location.state ? props.location.state.template : '',
    questionType: props.location.state ? props.location.state.questionType : '',
    category: props.location.state ? props.location.state.category : '',
    platform: props.location.state ? props.location.state.platform : '',
    answers: props.location.state ? props.location.state.answers : [],
    isActive: props.location.state ? props.location.state.isActive : '',
    newAnswers: [],
    removeAnswerIds: [],
  });

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setState((prev) => ({ ...prev, containerState: 'STATE_LOADING' }));

    const user = localStorageService.getUserOrThrow();
    const currentUserId = user.id;
    const answersList = [];
    const { questionId } = props.match.params;
    const { answers, platform, questionType, isActive, category, template } =
      state;

    const newAnswersList = answers.filter((answer) => !!answer.newAnswer);

    const a = [];

    // eslint-disable-next-line no-unused-expressions
    newAnswersList &&
      newAnswersList.map((newAnswer) =>
        a.push({
          template: newAnswer.template,
          order_weight: '1',
          added_by: currentUserId,
          platform,
        })
      );

    // eslint-disable-next-line no-unused-expressions
    answers &&
      answers
        .filter((answer) => !answer.newAnswer)
        .map((answer) =>
          answersList.push({
            id: answer.id,
            template: answer.template,
            order_weight: answer.order_weight,
            modified_by: currentUserId,
            platform,
          })
        );

    const payload = {
      update_details: {
        question_type: questionType,
        template,
        platform,
        is_active: isActive,
        category,
        added_by: currentUserId,
        answers: answersList,
        remove_answers: state.removeAnswerIds,
        new_answers: a,
      },
    };

    axios
      .put(`${environment.baseUrl}/questions/${questionId}`, payload)
      .then(() => {
        Swal.fire({
          title: 'Question successfully updated',
          icon: 'success',
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 10000,
          timerProgressBar: true,
        });
        setState((prev) => ({ ...prev, containerState: 'STATE_OK' }));
      })
      .catch((error) => {
        apiResponseHandler.handleApiError('Error', error);
        setState((prev) => ({ ...prev, containerState: 'STATE_ERROR' }));
      });
  };

  const handleAnswerInputChange = (i, value) => {
    setState((prev) => {
      const answers = [...prev.answers];
      answers[i] = { ...answers[i], template: value };
      return { ...prev, answers };
    });
  };

  const addClick = () => {
    setState((prev) => ({
      ...prev,
      answers: prev.answers.concat([{ newAnswer: true }]),
    }));
  };

  const removeClick = (i, answerId) => {
    setState((prev) => {
      const answers = [...prev.answers];
      answers.splice(i, 1);
      const removeAnswerIds = [...prev.removeAnswerIds];

      return {
        ...prev,
        answers,
        removeAnswerIds: answerId
          ? removeAnswerIds.concat([answerId])
          : removeAnswerIds,
      };
    });
  };

  if (state.containerState === 'STATE_LOADING') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <Loader2 className="h-6 w-6 animate-spin text-secondary-text-label" />
      </div>
    );
  }

  if (state.containerState === 'STATE_ERROR') {
    return (
      <div className="min-h-screen bg-white p-md">
        <Alert variant="destructive">
          <AlertDescription>An error occurred</AlertDescription>
        </Alert>
      </div>
    );
  }

  if (state.containerState === 'STATE_OK') {
    props.history.push('/admin/questions/education');
    return null;
  }

  if (!props.location.state) {
    props.history.push('/admin/questions/education');
    return null;
  }

  const { template, questionType, category, platform, isActive, answers } =
    state;
  const { questionId } = props.match.params;

  return (
    <div className="min-h-screen bg-white p-md">
      <div
        className="-mx-md -mt-md mb-md px-md py-lg"
        style={{ backgroundColor: 'rgba(237,244,251,0.5)' }}>
        <h1 className="m-none font-heading text-2xl font-semibold text-greyscale-text-title">
          Edit Question
        </h1>
        <p className="m-none mt-xxs max-w-2xl text-sm text-greyscale-text-body">
          Question #{questionId}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mx-auto w-full max-w-3xl">
        <div className="rounded-xl border border-greyscale-border-default bg-white p-md shadow-sm">
          <h2 className="m-none mb-sm font-heading text-lg font-semibold text-greyscale-text-title">
            Edit Question
          </h2>

          <div className="flex flex-col gap-sm">
            <div className="flex flex-col gap-xxs">
              <Label htmlFor="questionTemplate">Template</Label>
              <Textarea
                name="template"
                id="questionTemplate"
                value={template}
                onChange={(event) =>
                  setState({ ...state, template: event.target.value })
                }
                placeholder="Enter the question text"
              />
            </div>

            <div className="flex flex-col gap-xxs">
              <Label>Type</Label>
              <Select
                value={questionType}
                onValueChange={(value) =>
                  setState({ ...state, questionType: value })
                }>
                <SelectTrigger>
                  <SelectValue placeholder="Select type" />
                </SelectTrigger>
                <SelectContent>
                  {QUESTION_TYPES.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex flex-col gap-xxs">
              <Label>Platform</Label>
              <Select
                value={platform}
                onValueChange={(value) =>
                  setState({ ...state, platform: value })
                }>
                <SelectTrigger>
                  <SelectValue placeholder="Select platform" />
                </SelectTrigger>
                <SelectContent>
                  {PLATFORMS.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex flex-col gap-xxs">
              <Label>Category</Label>
              <Select
                value={category}
                onValueChange={(value) =>
                  setState({ ...state, category: value })
                }>
                <SelectTrigger>
                  <SelectValue placeholder="Select category" />
                </SelectTrigger>
                <SelectContent>
                  {CATEGORIES.map((option) => (
                    <SelectItem key={option} value={option}>
                      {option}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex items-center gap-xs">
              <Switch
                id="isActiveSwitch"
                checked={!!isActive}
                onCheckedChange={(checked) =>
                  setState({ ...state, isActive: checked })
                }
              />
              <div>
                <Label htmlFor="isActiveSwitch">Active</Label>
                <p className="m-none text-xs text-greyscale-text-caption">
                  Make this question visible in the chatbot.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-md rounded-xl border border-greyscale-border-default bg-white p-md shadow-sm">
          <div className="mb-sm flex items-center justify-between">
            <h2 className="m-none font-heading text-lg font-semibold text-greyscale-text-title">
              Answers
            </h2>
            <Button
              type="button"
              variant="outline"
              size="sm"
              leftIcon={<Plus className="h-4 w-4" />}
              onClick={addClick}>
              Add Answer
            </Button>
          </div>

          {!answers || answers.length === 0 ? (
            <p className="m-none text-sm text-greyscale-text-caption">
              No answers added yet.
            </p>
          ) : (
            <div className="flex flex-col gap-sm">
              {answers.map((answer, index) => (
                <div
                  key={answer.id ?? `answer-${index}`}
                  className="flex items-start gap-xs">
                  <Textarea
                    name="answer"
                    value={answer.template || ''}
                    onChange={(event) =>
                      handleAnswerInputChange(index, event.target.value)
                    }
                    placeholder={`Answer ${index + 1}`}
                    className="flex-1"
                  />
                  <Button
                    type="button"
                    variant="destructive"
                    size="sm"
                    leftIcon={<Trash2 className="h-4 w-4" />}
                    onClick={() => removeClick(index, answer.id)}>
                    Remove
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="mt-md flex justify-end gap-xs">
          <Button
            type="button"
            variant="outline"
            onClick={() => props.history.push('/admin/questions/education')}>
            Cancel
          </Button>
          <Button type="submit" variant="primary">
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditEducationQuestion;
